import { Button, Modal, Form, Row, Col, Select, Input, message } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { handleCreateModel } from "../../../../api/models";

const { Option } = Select;

export default function CreateModel({ isVisible, setVisible }: any) {
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const { mutate, isLoading } = useMutation({
    mutationFn: handleCreateModel,
    onSuccess: () => {
      message.success("Created Successfully");
      queryClient.invalidateQueries({ queryKey: ["models"] });
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const onSubmit = async () => {
    const { name, code, make } = await form.getFieldsValue();
    const data = {
      name,
      code,
      make,
    };
    await mutate(data);
    setVisible(false);
  };

  const makes = [
    { id: 1, name: "Toyota" },
    { id: 2, name: "Lexus" },
    { id: 3, name: "Hino" },
  ];

  const makeOptions = makes?.map((make: any, index: number) => (
    <Option value={make?.name} key={index}>
      {make?.name}
    </Option>
  ));

  const clearForm = async () => {
    form.resetFields();
  };

  return (
    <Modal
      open={isVisible}
      title="New Model"
      onCancel={() => setVisible(false)}
      footer={[
        <Button danger key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="createModel"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="createModel"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <div className="flex flex-row, justify-between"></div>

        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="name"
              label="Model Name"
              rules={[
                {
                  required: true,
                  message: "Please enter model name",
                },
              ]}
            >
              <Input type="" placeholder="Model Name" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="code"
              label="Model Code"
              rules={[
                {
                  required: true,
                  message: "Please enter model code",
                },
              ]}
            >
              <Input type="" placeholder="Model Code" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="make"
              label={"Make"}
              rules={[
                {
                  required: true,
                  message: "Please select make",
                },
              ]}
            >
              <Select placeholder="Make">{makeOptions}</Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
